// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.question-content-pdf[data-v-30cdcded] {\n  line-height: 1.8;\n  font-size: 14px;\n}\n.processed-content[data-v-30cdcded] p {\n  margin-bottom: 2px;\n}\n", ""]);
// Exports
module.exports = exports;
